import "./BreadcrumbMeeting.scss";

import { SbbTooltipElement } from "@sbb-esta/lyne-elements/tooltip.pure.js";
import { SbbTooltip } from "@sbb-esta/lyne-react/tooltip";
import { ellipsis } from "ApiConstraints";
import { DisplayLocked } from "components/DisplayFields/DisplayLocked";
import { formatTime } from "helpers";
import { createLogger } from "logging";
import { useMeeting, useTranslations } from "providers";
import React, { useId, useRef } from "react";

const logger = createLogger("BreadcrumbMeeting");

export const BreadcrumbMeeting: React.FC = () => {
  const i18n = useTranslations();
  const { isLoading, meeting } = useMeeting();
  const statusTriggerId = useId();
  const statusTooltipRef = useRef<SbbTooltipElement | null>(null);

  if (isLoading) {
    return null;
  }

  if (!meeting) {
    return null;
  }

  const { id: meetingId, title = "", locked, overlength, isTemplate } = meeting;
  logger.trace(`render(): `, JSON.stringify({ meetingId, isLoading, overlength, isTemplate }));

  let displayTitle = title || ellipsis;
  if (displayTitle.length > 50) {
    displayTitle = `${displayTitle.substring(0, 49)}${ellipsis}`;
  }

  const titleTemplate = isTemplate ? i18n.Page_StandardMeetingName_Title : i18n.Page_MeetingName_Title;
  const longTitle = titleTemplate.replace("{0}", title);
  const shortTitle = titleTemplate.replace("{0}", displayTitle);

  return (
    <div className="breadcrumb-meeting">
      <span className="title global-tooltip-trigger" sbb-tooltip={longTitle}>
        {shortTitle}
      </span>
      <span
        id={statusTriggerId}
        className={overlength ? "meeting-status-red" : "meeting-status-green"}
        tabIndex={0}
        role="img"
      >
        <i className="ms-Icon ms-Icon--CircleFill" aria-hidden="true" />
      </span>

      <DisplayLocked value={locked} entityName="Meeting" name="Locked" />

      <SbbTooltip ref={statusTooltipRef} trigger={statusTriggerId} /*closeDelay={100_000}*/>
        <dl className="meeting-status-times">
          <dt>{i18n.Meeting_EventTime_Title}</dt>
          <dd>{formatTime(meeting.eventDate, ellipsis)}</dd>

          <dt>{i18n.Meeting_PlannedEndTime_Title}</dt>
          <dd>{formatTime(meeting.endDate, ellipsis)}</dd>

          <dt>{i18n.Meeting_ProjectedEndTime_Title}</dt>
          <dd>
            {formatTime(meeting.projectedEndDate, ellipsis)} <span className="difference">{meeting.difference}</span>
          </dd>
        </dl>
      </SbbTooltip>
    </div>
  );
};
